import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { getPopularComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const popularComics = getPopularComics(6);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h3 className="text-xl md:text-2xl font-heading text-foreground-900">热门推荐</h3>
            <p className="text-sm text-foreground-500 mt-1">全网最受欢迎的漫画作品</p>
          </div>
          <Link
            to="/category/korean"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {popularComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}